export const PRODUCT_HISTORY_SIZE = 5;

// This needs to be a `string` because it is bundled multiple times:
// - once with angular cli for server bundle
// - once directly with webpack when building the server
// Using `InjectionToken` wouldn't work as it would compare 2 different references.
export const STARTUP_CONTEXT_TOKEN = "T_STARTUP_CONTEXT";
export const OBG_NODE_CONTEXT_TOKEN = "OBG_NODE_CONTEXT_TOKEN";

export const OBG_EVENT_BUS = "OBG_EVENT_BUS";

export const APP_DEP_MFES_TOKEN = "APP_DEP_MFES_TOKEN";
export const APP_DEP_GDPR_COUNTRIES_TOKEN = "APP_DEP_GDPR_COUNTRIES_TOKEN";
export const APP_DEP_ROUTES_TOKEN = "APP_DEP_ROUTES_TOKEN";
export const APP_DEP_CONFIG_TOKEN = "APP_DEP_CONFIG_TOKEN";
export const APP_DEP_TRANSLATED_EXTERNAL_ROUTES_TOKEN = "APP_DEP_TRANSLATED_EXTERNAL_ROUTES_TOKEN";
